import { render, staticRenderFns } from "./WelcomeContentComponent.vue?vue&type=template&id=14aa4ffe&scoped=true&"
import script from "./WelcomeContentComponent.vue?vue&type=script&lang=js&"
export * from "./WelcomeContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeContentComponent.vue?vue&type=style&index=0&id=14aa4ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa4ffe",
  null
  
)

export default component.exports